module.exports = __webpack_public_path__ + "static/media/Oldham-Project-5-370x247.2d534d9e.jpg";